let customWindow: any = window;
customWindow.ENVIRONMENT = 'production';
customWindow.API_URL = 'https://api.fanaticka.eu/api/v1';
customWindow.APP_INSIGHTS_ID = '903b769b-906d-4730-bb7f-0619f82d1d2d';
customWindow.STRIPE_KEY = 'pk_live_51SXgIG1K1qTb09NHKgVWqLUD5GSXeXA1iMBbggbVCjbd1tXM0e2K3MX4UYPYfi5xtBW0B3qCe5gZeFVxcPv6pDEG00e9PfOqzz';
customWindow.STRIPE_TM_KEY = 'pk_live_51OaDN2CYZVeiCZqGVvON9PP5nkBUd3rpYPqKuu0fFJzZ4tTnGHLyFrdEvHcRNjT5lYHrLllvTNFUfs3QyfExiSBS00HF8oIIA1';
customWindow.STRIPE_US_KEY = 'pk_live_fwrIleb9sARM3UwShZwslggL008kGvMG00';
customWindow.REACT_APP_FREEDOM_PAY_API_PUBLISHABLE_TOKEN = 'st3bxgRr38qeSe4OCIx3HU3FYLmWcMJA'

import './index.tsx';
